var indentation_default = {
  "indentZero": "xFml2",
  "indentOne": "_1RlHy",
  "indentTwo": "niEsh",
  "indentThree": "D89Z7",
  "indentFour": "f-F1p",
  "indentFive": "t8N2D",
  "indentSix": "_2zqWC"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
